<template>
  <section>
    <div class="form-header">
      <div id="rules">
        <h3>Password Requirements:</h3>
        <ul>
            <li v-for="(rule, index) in ruleLines" :key="index">
              {{ rule }}
            </li>
        </ul>

        <h3>Method 1: Use JAMF Connect to change your password</h3>
        <p><em>(Only if you know your current password)</em></p>
        <ol>
          <li>If at a CW location, skip to step 2. If remote, connect to the VPN.</li>
          <li>Click the globe icon on your menu bar.<img src="../../../public/assets/cwi-globe.png" height="15" width="20" alt="globe_icon"/></li>
          <li>Type your username (not full email) and password, then click connect.</li>
          <li>Approve the Duo notification from your phone.</li>
          <li>Click JAMF Connect on your menu bar (near time and date).<img src="../../../public/assets/cwi-jamf.png" height="29" width="19" alt="jamf_icon"/></li>

          <li>Click “Change password”.</li>
          <li>In the dialog, enter:
            <ul>
              <li>Your old password</li>
              <li>Your new password</li>
              <li>Verify new password</li>
            </ul>
          </li>
          <li>Click “Change password”.</li>
        </ol>
        <p>This will change your CW and local password simultaneously.</p>

        <h3>Method 2: Change your password on <code>me.rv.com</code> then sync with JAMF Connect</h3>
        <p><em>This works whether you know your current password or not, and does not require VPN.</em></p>
        <p><strong>Note:</strong> <em>Network Password = CW Password, Local Password = Mac Password</em></p>
        <ol>
          <li>Open a browser and go to <code>me.rv.com</code></li>
          <li>Click “Reset Password”</li>
          <li>Enter your username, click “Next”</li>
          <li>Choose a verification method (text or email)</li>
          <li>Enter your phone/email and click “Next”</li>
          <li>Enter the security code</li>
          <li>Create and confirm a new password, then click “Submit”</li>
          <li>Click JAMF Connect from your Mac menu bar<img src="../../../public/assets/cwi-jamf.png" height="29" width="19" alt="jamf_icon"/></li>

          <li>Click “Log In”</li>
          <li>Enter your CW email in the username field</li>
          <li>Enter your new CW password</li>
          <li>When prompted that passwords don’t match, enter your old local (Mac) password</li>
        </ol>
        <p>Your new CW password is now synced with your local Mac password.</p>
      </div>
    </div>
    <hr>
    <div>
      <b-form>
        <div>
          <b-button @click="goBack" variant="primary">Back</b-button>
        </div>
      </b-form>
    </div>
  </section>
</template>

<script>
/* eslint-disable no-undef */

import {mapActions} from "vuex";

/***************************************************
 * The FormMacPWR component
 *
 * Information page for Mac Users
 *
 ***************************************************/

export default {
  name: 'FormMacPWR',
  data () {
    return {
      spinner: false,
      ruleLines: []
    }
  },
  computed: {},
  methods: {
    ...mapActions('localApi',['getPasswordRules']),
    async goBack () {
      this.$router.push('/');
    },
  },
  async mounted () {
    this.ruleLines = await this.getPasswordRules({accountType:this.getUserType, gradeLevel: this.getGradeLevel});
  }
}
</script>

<style scoped>
form-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 25px 0;
}

h1 {
  font-weight: bold;
  color: #000;
}

h3 {
  color: #4A4A4A;
}

form {
  display: flex;
  flex-direction: column;
}

button {
  margin: 15px 0px;
  background-color: #5487BA;
  width: 100px;
  font-weight: bold;
}

button:hover {
  background-color: #123A5D;
}

#rules {
  background-color: #f5f5f5;
  width: 100%;
  font-size: 1rem;
  padding: 10px;
  text-align: left;
}
</style>
